var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconFileErrorComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? false : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-file_error ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64941 3.10938V36.8709H34.3499V14.248L23.124 3.10938H5.64941ZM8.14941 34.3709V5.60937H21.4139L21.436 16.0411H31.8499V34.3709H8.14941ZM30.088 13.5411L23.9177 7.41867L23.9307 13.5411H30.088Z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 32C39 28.134 35.866 25 32 25C28.134 25 25 28.134 25 32C25 35.866 28.134 39 32 39C35.866 39 39 35.866 39 32Z",
    fill: useCurrentColor ? 'currentColor' : '#EA3D4C'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2549 34.0836L28.8305 34.5077L29.6793 35.3558L30.1038 34.9317L31.9987 33.0383L33.9095 34.9476L34.3339 35.3717L35.1828 34.5235L34.7584 34.0994L32.8475 32.1901L34.8999 30.1395L35.3243 29.7154L34.4754 28.8672L34.051 29.2913L31.9987 31.342L29.9623 29.3072L29.5378 28.8831L28.689 29.7313L29.1134 30.1554L31.1498 32.1901L29.2549 34.0836Z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }));
}
var IconFileError = /*#__PURE__*/React.forwardRef(IconFileErrorComponent);
export default IconFileError;